// Need to use the React-specific entry point to import createApi
import {apiSlice} from './apiSlice';

export const leadApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLeads: builder.query({
      query: filter => {
          const qs = new URLSearchParams(filter).toString();
          return 'lead' + (qs ? '?' + qs : '');
      },
      providesTags: ['Lead', 'LeadComment', 'Patient', 'Provider'],
    }),
    createLead: builder.mutation({
      query: body => ({
        url: 'lead/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Lead', 'Patient'],
    }),
    signupLead: builder.mutation({
      query: body => ({
        url: 'lead_signup/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Lead', 'Patient'],
    }),
    updateLead: builder.mutation({
      query: ({id, body}) => ({
        url: `lead/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Lead', 'Patient'],
    }),
    createLeadComment: builder.mutation({
      query: body => ({
        url: 'lead_comment/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Lead', 'Patient', 'LeadComment'],
    }),
    removeLeadComment: builder.mutation({
      query: id => ({
        url: `lead_comment/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Lead', 'LeadComment'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetLeadsQuery,
  useCreateLeadMutation,
  useSignupLeadMutation,
  useUpdateLeadMutation,
  useCreateLeadCommentMutation,
  useRemoveLeadCommentMutation,
} = leadApi;
